

import React, { useRef, useState, useEffect, useContext } from 'react';
import profileImage from '../../assets/images/profile_.png';
import { IconButton, InputAdornment, TextField } from '@mui/material';
import sendIcon from '../../assets/images/sendicon.png';
import noahAvatar from '../../assets/images/Icon_Logo.png';
import './RightChatComponent.css';
import ChatWithLLM from '../../Apis/ChatWithLLM';
import FetchChatHistoryById from '../../Apis/FetchChatHistoryById';
import { useParams } from 'react-router-dom';
import MyContext from '../../Context/AppContext';
import { useNavigate } from 'react-router-dom'
import { showToast } from '../../utils/toastUtils';
import { KeyboardVoice, StopCircle } from '@mui/icons-material';
import SpeechRecognition, { useSpeechRecognition } from 'react-speech-recognition';
import BackDropLoader from '../backDropLoader/BackDropLoader';

const RightChatComponent = (props) => {
 const { setGetRecentHistory, getRecentHistory, jobDescriptionStatus, setJobDescriptionStatus, checkLimitExceed,
        openDrawer, setIsBackdropEnabled, resetJobDescriptionStatus, userDetails, limitExceededApiRunning,
        chatLimitExceeded, setChatLimitExceeded, setUpgradeModalOpen } = useContext(MyContext);
    const [chatHistory, setChatHistory] = useState([]);
    const [currentUserInput, setCurrentUserInput] = useState('');
    const [userInputWithoutTranscript, setUserInputWithoutTranscript] = useState('');
    const [isBotThinking, setIsBotThinking] = useState(false);
    const [isVoiceEnabled, setIsVoiceEnabled] = useState(false);
    const scrollContainerRef = useRef(null);
    const lastFetchedId = useRef(null);
    const inputRef = useRef(null)
    const { id } = useParams();
    const {
        transcript,
        resetTranscript,
    } = useSpeechRecognition();
    const navigate = useNavigate();

    const handleCurrentUserInput = (e) => {
        resetTranscript();
        setCurrentUserInput(e.target.value);
        setUserInputWithoutTranscript(e.target.value);
    };

    const handleSendMesaage = async () => {
        if (currentUserInput === '') return;

        const newUserMessage = {
            title: 'You',
            description: currentUserInput,
        };
        resetTranscript();
        setChatHistory((prevHistory) => [...prevHistory, newUserMessage]);
        setCurrentUserInput('');
        setUserInputWithoutTranscript('');
        setIsVoiceEnabled(false);
        SpeechRecognition.stopListening();
        setIsBotThinking(true);
        handleChatWithLLM();
    };

    const handleSupportClick = () => {
        setUpgradeModalOpen(true);
    };

    useEffect(() => {
        window.handleSupportClick = handleSupportClick;
        return () => {
            delete window.handleSupportClick;
        };
    }, []);

    const formatTextWithNewlines = (text) => {
        if (!text) return null;
        
        // First split the text into lines
        const lines = text.split("\n");
        
        // Process each line
        return lines.map((line, index) => {
            // Check if the line contains our special link
            if (line.includes('onClick={myFunction()}')) {
                // Replace the placeholder with actual onclick handler
                const processedLine = line.replace(
                    /<a href='#' onClick={myFunction\(\)}>([^<]+)<\/a>/g,
                    `<a href="#" class="support-link" onclick="handleSupportClick()">\$1</a>`
                );
                return (
                    <React.Fragment key={index}>
                        <div dangerouslySetInnerHTML={{ __html: processedLine }} />
                        <br />
                    </React.Fragment>
                );
            }
            // Return normal line
            return (
                <React.Fragment key={index}>
                    {line}
                    <br />
                </React.Fragment>
            );
        });
    };

    const goToNewChat = async () => {

        setJobDescriptionStatus({
            isContinueChat: false,
            isEmailSent: false,
        });

        let limitExceedStatus = await checkLimitExceed()
        let createJdAccess = userDetails?.accountConfig?.permissions?.createJd
         if (limitExceedStatus || createJdAccess === false) {
            navigate('/app/limitExceeded')
        }
        else {
            navigate(`/app/chat`);
        }
    }

    const handleChatWithLLM = async () => {
        const userId = userDetails?._id;
        const data = { sessionId: id, message: currentUserInput, userId: userId };
        const response = await ChatWithLLM(data);
        let jobDescriptionStatusResponse = {
            isContinueChat: response?.data?.isContinueChat,
            isEmailSent: response?.data?.isEmailSent,
        }
        setChatLimitExceeded(response?.data?.isChatLimitExceeded)
        setJobDescriptionStatus(jobDescriptionStatusResponse);
        let botResponse = response?.data?.response;


        setChatHistory((prevHistory) => [
            ...prevHistory,
            {
                title: 'Noah',
                description: botResponse,
            },
        ]);
        setIsBotThinking(false);
        setTimeout(() => {
            inputRef.current?.querySelector('input')?.focus();
        }, 100);
        if (jobDescriptionStatusResponse.isEmailSent === true && jobDescriptionStatusResponse.isContinueChat === true) {
            showToast('Thank you for generating the job description. You will be redirected to a new chat window shortly', 'success');
            setTimeout(() => {
                goToNewChat();
            }, 5000);
        }
    };

    const userName = userDetails?.name;
    function formatName(str) {
        return str.charAt(0).toUpperCase() + str.slice(1);
    }

    const handleVoiceChat = () => {
        if (!isVoiceEnabled) {
            setIsVoiceEnabled(true);
            SpeechRecognition.startListening({ continuous: true });
        } else {
            setIsVoiceEnabled(false);
            SpeechRecognition.stopListening();
        }
    }

    useEffect(() => {
        if (transcript) {
            let updatedTranscriptText = "";
            updatedTranscriptText = userInputWithoutTranscript + transcript;
            setCurrentUserInput(updatedTranscriptText);
        }
    }, [transcript, userInputWithoutTranscript]);


    useEffect(() => {
        async function fetchData() {
            if (!id || lastFetchedId.current === id) return;
            lastFetchedId.current = id;
            SpeechRecognition.stopListening();
            setCurrentUserInput('');
            setIsBackdropEnabled(true);
            resetJobDescriptionStatus();
            setChatHistory([]);
            await fetchChatHistory();
            resetTranscript();
            setIsVoiceEnabled(false);
        }
        fetchData();
    }, [id]);

    useEffect(() => {
        if (limitExceededApiRunning) {
            setIsBackdropEnabled(true)
        }
    },[limitExceededApiRunning])


    const fetchChatHistory = async () => {
        try {
            const response = await FetchChatHistoryById(id);

            if (response.data.response.data.length === 0) {
                let limitExceedStatus = await checkLimitExceed()
                let createJdAccess = userDetails?.accountConfig?.permissions?.createJd
                if (limitExceedStatus || createJdAccess === false) {
                    navigate('/app/limitExceeded')
                    return;
                }
                const userId = userDetails?._id;
                const data = { sessionId: id, message: 'Start Over', userId: userId };
                await ChatWithLLM(data);
                setChatHistory([]);
            } else {
                let responseData = response?.data?.response?.data[0].history;
                let chatData = [];
                for (let i = 0; i < responseData.length; i++) {
                    let obj = {};
                    if (responseData[i].type === 'human') {
                        obj.title = 'You';
                        obj.description = responseData[i].content;
                    } else if (responseData[i].type === 'ai') {
                        obj.title = 'Noah';
                        obj.description = responseData[i].content;
                    }
                    chatData.push(obj);
                }
                setChatHistory(chatData || []);

                if (chatData.length > 0) {
                    let responseData = await ChatWithLLM({ sessionId: id, message: 'continue chat', userId: userDetails?._id });
                    setJobDescriptionStatus({
                        isContinueChat: responseData?.data?.isContinueChat,
                        isEmailSent: responseData?.data?.isEmailSent,
                    })
                }
            }
        } catch (error) {
            console.error('Error fetching chat history:', error);
            setChatHistory([]);
        } finally {
            setIsBackdropEnabled(false)
        }
    };

    useEffect(() => {
        if (scrollContainerRef.current) {
            scrollContainerRef.current.scrollTo({
                top: scrollContainerRef.current.scrollHeight,
                behavior: 'smooth',
            });
        }
    }, [chatHistory]);

    return (
        <div className={openDrawer ? "mainContainer_chatDiv drawerOpen_chatContainer" : "mainContainer_chatDiv"}>
            <div ref={scrollContainerRef} className={chatHistory.length > 0 ? 'chatContainer' : 'chatContainer_blank'}>

                {chatHistory.length === 0 ? (
                    <div className="chatGreetingContent">

                        <span className="chatGreetingTitle">Hello, {userName ? formatName(userName) : "User"}</span>
                        <span className="chatGreetingTitle2">How can I help you today?</span>
                    </div>
                ) : (
                    <div className="chatContentContainer">

                        {chatHistory.map((chat, index) => {
                            return (
                                <div key={index} className={chat.title === 'You' ? 'chatContentDiv rightAllignmentMessage' : 'chatContentDiv'}>
                                    <span className={chat.title === 'You' ? 'senderTitle_user' : 'senderTitle'}>
                                        {chat.title}
                                    </span>
                                    <div className={chat.title === 'You' ? 'senderMessageContainer senderMessageContainerReverse' : 'senderMessageContainer'}>
                                        {chat.title === 'You' ? (
                                            <img src={profileImage} className="senderAvatar" alt="sendAvatar" />
                                        ) : (
                                            <img src={noahAvatar} className="senderAvatar" alt="sendAvatar" />
                                        )}
                                        <div className={chat.title === 'You' ? 'senderMessageDiv_user' : 'senderMessageDiv'}>
                                            {formatTextWithNewlines(chat.description)}
                                        </div>
                                    </div>
                                </div>
                            );
                        })}
                        {isBotThinking && (
                            <div className="chatContentDiv">
                                <span className="senderTitle">Noah</span>
                                <div className="senderMessageContainer">
                                    <img src={noahAvatar} className="senderAvatar" alt="sendAvatar" />
                                    <div className="senderMessageDiv BotLoaderDiv">
                                        <div className="botResponseloader"></div>
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                )}
            </div>

            {(chatLimitExceeded && !jobDescriptionStatus?.isEmailSent) &&
                <div className='chatLimitExceededContainer'>
                    <span className='chatLimitText'>
                        ** Your chat limit has been exceeded. To increase your limit, please contact support.
                    </span>
                </div>
            }

            {jobDescriptionStatus?.isEmailSent === true ?
                <div className='chatLimitExceededContainer jdCreatedContainer'>
                    <span className='chatLimitText'>** The job description for this chat has already been generated. To create a new one, please </span>
                    <span className='newChatCreateText' onClick={() => goToNewChat()}> click here</span>
                </div>
                :
                <div className="chatInputBoxCaontainer">
                    <TextField
                        className='chatInputBox'
                        id="outlined-multiline-flexible"
                        multiline
                        maxRows={6}
                        placeholder="Ask me anything..."
                        onChange={handleCurrentUserInput}
                        disabled = {chatLimitExceeded}
                        autoComplete="off"
                        onKeyDown={(e) => {
                            if (e.key === 'Enter' && !e.shiftKey && currentUserInput !== '' && !isBotThinking) {
                                e.preventDefault();
                                handleSendMesaage();
                            }
                        }}
                        value={currentUserInput}
                        slotProps={{
                            input: {
                                endAdornment: <InputAdornment position="end">
                                    <div className='wrapper'>
                                        <div className='voiceConatinerMain'>
                                            {isVoiceEnabled && (
                                                <div>
                                                    <div class="waves-block">
                                                        <div class="waves wave-1"></div>
                                                        <div class="waves wave-2"></div>
                                                        <div class="waves wave-3"></div>
                                                    </div>
                                                </div>)}
                                            <IconButton className='voiceEnableIcon' onClick={() => handleVoiceChat()} disabled = {chatLimitExceeded}>
                                                {isVoiceEnabled ? <StopCircle /> :
                                                    <KeyboardVoice />
                                                }
                                            </IconButton>
                                        </div>

                                    </div>

                                </InputAdornment>,
                            },
                        }}
                    />
                    <IconButton className="sendIconButton" onClick={handleSendMesaage} disabled={isBotThinking || chatLimitExceeded}>
                        <img src={sendIcon} alt="sendIcon" className={isBotThinking || currentUserInput.length <= 0 ? 'sendIconButtonDisabled sendIconImage' : 'sendIconImage'} />
                    </IconButton>
                </div>
            }
            <BackDropLoader />
        </div>
    );
};

export default RightChatComponent;
